import { gql } from '@apollo/client';

const DIAGNOSIS_CODES_QUERY = gql`
  query diagnosisCodes($filter: DiagnosisCodesFilter!, $limit: Int) {
    diagnosisCodes(filter: $filter, limit: $limit) {
      id
      fullDisplay
    }
  }
`;

export default DIAGNOSIS_CODES_QUERY;
